export class Area {
    public idArea: number;
    public idSubArea: number;
    public idPadre: number;
    public idEmpresa: number;
    public descripcion: string;
    public descripcionPadre: string;
    public activo: boolean;
    public tipo: string;
    
    //Paginacion Respuesta lstZonas
    public page: number;
    public rows: number;
    public start: number;
    public length: number;
    public total: number;

    constructor() {
        this.idArea = -1;
        this.idSubArea = 0;
        this.idPadre = 0;
        this.idEmpresa = -1;
        this.descripcion = '';
        this.descripcionPadre = '';
        this.activo = true;

        this.page = 1;
        this.rows = 10;
        this.start = 0;
        this.length = 0;
        this.total = 0;
    }
    
}